import React, { useState, useCallback, useEffect, useMemo, useContext } from 'react';
import { IntlProvider, FormattedMessage } from 'react-intl';
import { injectIntl, intlShape } from 'react-intl';
import {AuthenticationContext} from '../AuthenticationContextProvider';
import { useLocation } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import {ConfigContext} from '../ConfigContextProvider';

import {
  NavLink,
  Link
} from "react-router-dom";

const NavigationBar = (props) => {
  const [items, setItems] = useState(props.items);
  const history = useHistory();
  const { DOWNLOAD_URL } = useContext(ConfigContext);
  const {APPID} = useContext(ConfigContext);
  const {userOptions} = useContext(AuthenticationContext);

  const downloadDetailHandler= useCallback((link, label, action) => {


    if(userOptions && Number(userOptions.login)) {

      let filename= link;
      let pos = String(link).lastIndexOf(".")
      let ext=  link.substr(pos+1);
      let filenameNoPath= link.substr(String(link).lastIndexOf("/")+1);



      if(window.mainunity && window.mainunity==="in" ) {
        filename = link.substring(0, pos);
        filename +="_in."+ link.substr(pos+1);
      }

      window.sendToGTM({
        event: "file_download",
        category: "3dlibrary",
        action: action,
        label: label,
        file_name: filenameNoPath,
        file_extension: ext
      })


      window.location.href= DOWNLOAD_URL + "?file="+ filename;
    } else {
      const event = new CustomEvent("login", {'detail': {APPID:APPID, fMode:"LOGIN", namespace:"modalAuth"} });
      document.dispatchEvent(event);
    }
  });
  
  const orderHandler= useCallback((e) => {
    const id=e.target.value;
    if(id && id != 0) { 
      history.push(`/${type.url}/${id}`);
    }
  });

  const categoryOrderHandler= useCallback((e) => {
    const id=e.target.value;
    if(id && id != 0) { 
      history.push(`/${type.url}/${category.url}/${id}`);
    }
  });

  const {type, category, order} = props;

  return (
    <header className="navigation__header">
      <div className="navigation__wrapper">
        <>
          <div className="navigation__listWrapper">
            <ul className="navigation__list">
              { items.map((item, i) => (
                  <NavLink to={`/${item.url}`} key={`navlink_${i}`} className={"navigation__link navigation__link--type"} activeClassName="active"><FormattedMessage id={item.name} /></NavLink>
              ))}
            </ul>
          </div>
          <div className="container">
          <div className="navigation__options">
            <div>
              {type && type.order && type.order.length >0 && 
                <div className="navigation__selectOrder">
                  <span className="selectOrder__label"><FormattedMessage id={"label.orderby"} /> </span>
                  <select className="selectOrder" value={order && order.url} onChange={ orderHandler}>
                    {type.order.map((item, i) => (
                      <option key={"option"+i} value={item.url} >{props.intl.formatMessage({id: item.name})}</option>
                    ))}
                  </select>
                </div>
              }

              {category && category.order && category.order.length >0 && 
                <div className="navigation__selectOrder">
                  <span className="selectOrder__label"><FormattedMessage id={"label.orderby"} /> </span>
                  <select className="selectOrder" value={order && order.url} onChange={ categoryOrderHandler}>
                    {category.order.map((item, i) => (
                      <option key={"option"+i} value={item.url} >{props.intl.formatMessage({id: item.name})}</option>
                    ))}
                  </select>
                </div>
              }
              
              </div>

            <div>
              {type && type.category && type.category.length >0 && <ul className="navigation__category">
                  {type.category.map((item, i) => (
                    <NavLink to={`/${type.url}/${item.url}`} key={`catlink_${i}`} className={"navigation__link"} activeClassName="active"><FormattedMessage id={item.name} /></NavLink>
                  ))}
              </ul>}
            </div>
            <div>
              {<ul className="download__list">
                  {type && type.downloads && type.downloads.map((download, i) => (
                    <li key={"download_link_"+i}>
                      <a className="download__link" onClick={(e) => {e.preventDefault(); downloadDetailHandler(download.link, props.intl.formatMessage({id: download.name}), "All") }} >
                        <span className="icon__download">
                          <svg width="13.981" height="18.286" viewBox="0 0 13.981 18.286"><g transform="translate(0 2)"><rect className="a" width="13.981" height="2.33" transform="translate(0 13.957)"/><path className="a" d="M21.847-61.3,20.2-62.944l-4.257,4.257v-9.869H13.765v9.869L9.508-62.944,7.866-61.3l6.991,6.991Z" transform="translate(-7.865 66.556)"/></g></svg>
                        </span>
                        <FormattedMessage id={download.name} />
                      </a>
                    </li>
                  ))}
              </ul>}
            </div>
          </div>
          </div>
        </>
      </div>
    </header>
  );
}

export default injectIntl(NavigationBar);